/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".circle-settings[_ngcontent-%COMP%]{padding-top:3.75rem}@media (min-width:768px){.circle-settings[_ngcontent-%COMP%]{padding-top:4.375rem}}@media (min-width:992px){.circle-settings[_ngcontent-%COMP%]{padding-top:0;overflow-y:auto}}"];
export { styles as styles };
